import { MenuSortOrder } from 'enums/SortOrder/MenuSortOrder';
import { QueryParams } from 'functions/getQueryParams';
import IAdvancedSearchKey from 'interfaces/IAdvancedSearchKey';

export default class NullableMenuSortOrder implements IAdvancedSearchKey {
	public id: string;
	public value: MenuSortOrder | null;
	public defaultValue: MenuSortOrder;

	constructor(id: string, defaultValue: MenuSortOrder) {
		this.id = id;
		this.value = null;
		this.defaultValue = defaultValue;
	}

	public reset() {
		this.value = null;
	}

	public mapResponse(input: MenuSortOrder) {
		this.value = input;
	}

	public mapFromUrl(input: QueryParams): void {
		for (const [key, value] of Object.entries(input)) {
			if (key === this.id) {
				this.value = value ? (value as MenuSortOrder) : null;
			}
		}
	}

	public mapToUrl(): string | null {
		if (this.value) {
			return this.id + '=' + this.value;
		}
		return null;
	}

	public mapToApi(): MenuSortOrder {
		if (this.value === null) {
			return this.defaultValue;
		}
		return this.value;
	}
}
